import { barberTestAccountIdList, shopTestAccountIdList } from '../config';
import { SearchResult } from '../types/results';

/**
 * Removes known test/demo shop and barber accounts (configured via
 * REACT_APP_SHOP_TEST_ACCOUNT_ID_LIST / REACT_APP_BARBER_TEST_ACCOUNT_ID_LIST)
 * from a list of search results so they never surface to real customers.
 */
export const filterOutTestAccounts = (
  results: SearchResult[]
): SearchResult[] =>
  results.filter((result) => {
    if (result.id === undefined || result.id === null) return true;

    const id = BigInt(result.id);

    if (result.type === 'SHOP') {
      return !shopTestAccountIdList.includes(id);
    }

    if (result.type === 'BARBER') {
      return !barberTestAccountIdList.includes(id);
    }

    return true;
  });
